import { Component, Input } from '@angular/core';
import { ConfirmPaymentService } from '../../services/confirm_payment.service';
import { AnalyticsUtilsService } from '../../shared/analytics-utils.service';


declare var saveAs:any;

@Component({
  selector: 'download-voucher',
  template: `<button *ngIf="!isNode" class="new_button" (click)="downloadVoucher()">
                {{'CONFIRMATION_DOWN' | translate}}
                <i class="material-icons">get_app</i> 
              </button>`,
styleUrls:['./download.components.scss']

})
export class DownloadVoucherComponent {
  @Input() oldToken:string;
  public isNode:boolean;
  public item:Object={sales:[]};
  public total:number = 0; 
  public currencyStr:string = "EUR";
  
  constructor(private confirmPaymentSercive:ConfirmPaymentService,
    private analytics:AnalyticsUtilsService) {
    
  }

  downloadVoucher(){
    this.analytics.click_on_download();
    let token = this.oldToken.split('Bearer ');
    let externalUrl = this.confirmPaymentSercive.getVoucher(token[1]);
    window.open(externalUrl,'_blank');
  }
}